import { render, staticRenderFns } from "./HeaderMobile.vue?vue&type=template&id=088488dd&scoped=true"
import script from "./HeaderMobile.vue?vue&type=script&lang=js"
export * from "./HeaderMobile.vue?vue&type=script&lang=js"
import style0 from "./HeaderMobile.vue?vue&type=style&index=0&id=088488dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088488dd",
  null
  
)

export default component.exports